import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import classNames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import useSearchHotKey from '@/hooks/useSearchHotKey'
import useAutoCompleteAction from '@/hooks/useAutoCompleteAction'

// Components
import Icon from '@/assets/icons'
import InputComponent from '@/components/common/Input/index'
import AutoComplete from './components/AutoComplete'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Styles
import styles from './style.module.scss'

const cx = classNames.bind(styles)

const SearchInput = () => {
  const router = useRouter()
  const isTag = router.pathname === ROUTE_PATH.SEARCH_TAG
  const {
    handleKeyPress,
    handleKeyDown,
    autoCompleteKeyword,
    setAutoCompleteKeyword,
    autoCompleteIsOpen,
    setAutoCompleteIsOpen,
    autoCompleteSelectIndex,
    setAutoCompleteSelectIndex,
    inputRef,
  } = useAutoCompleteAction()

  const { filterKeywordList = [] } = useSearchHotKey({ autoCompleteKeyword: autoCompleteKeyword })

  const { t } = useTranslation()

  useEffect(() => {
    if (router.isReady) {
      if (router.query.keyword) {
        setAutoCompleteKeyword(router.query.keyword as string)
      }
    }
  }, [router.isReady, router.query])
  return (
    <div className={cx('search-input')}>
      <div className={cx('search-input-icon')}>
        <Icon.LongHandleSearch />
      </div>
      <div ref={inputRef} style={{ width: '100%' }}>
        <InputComponent
          onKeyPress={handleKeyPress}
          onKeyDown={handleKeyDown}
          className={cx('search-input-text')}
          wrapperClassName={cx('search-input-text-wrapper')}
          placeholder={t('Search_Search')}
          onChange={(e) => {
            setAutoCompleteKeyword(e.target.value)
            setAutoCompleteSelectIndex(null)
            setAutoCompleteIsOpen(true)
          }}
          value={autoCompleteKeyword as string}
        />
      </div>
      <div className={cx('search-input-icon-clear')} onClick={() => setAutoCompleteKeyword('')}>
        <Icon.Close />
      </div>
      {autoCompleteIsOpen && filterKeywordList.length > 0 && (
        <AutoComplete
          isOpen={autoCompleteIsOpen}
          filterKeyWord={!isTag ? filterKeywordList : []}
          className={cx('search-input__auto-complete')}
          activeIndex={autoCompleteSelectIndex}
          handleClick={(selectedKeyword: string) => {
            setAutoCompleteIsOpen(false)
            setAutoCompleteKeyword(selectedKeyword)
          }}
        />
      )}
    </div>
  )
}
export default SearchInput
